import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Slider from 'react-slick';

const BlogArea = () => {
  // New game content
  const gameContents = [
    {
      title: "Action Game",
      description: "Create fast-paced games focused on quick reflexes, combat, and intense challenges.",
      img: "assets/img/images/Gamesguru - Our Games Type 1.png"
    },
    {
      title: "Multiplayer Game",
      description: "Develop engaging games where multiple players compete or cooperate in real time.",
      img: "assets/img/images/Gamesguru - Our Games Type 2.png"
    },
    {
      title: "Racing Game",
      description: "Design thrilling games centered on speed, vehicles, and competitive racing tracks.",
      img: "assets/img/images/Gamesguru - Our Games Type 3.png"
    },
    {
      title: "Sports Game",
      description: "Build realistic or arcade-style games that simulate popular sports and athletic competition.",
      img: "assets/img/images/Gamesguru - Our Games Type 4.png"
    }
  ];

  return (
    <section className="blog-area pt-40">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title home-four-title black-title text-center mb-65">
              <h2>Our Game <span>Types</span></h2>
              <p>Explore the types of games we develop to entertain and engage your audience.</p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center md">
          {gameContents.map((item, i) => (
            <div key={i} className="col-lg-3 col-md-6 col-sm-9 flex">
              <Link to="/web-games" className="blog-post home-four-blog-post mb-50">
                <div className="blog-thumb mb-30 flex">
                  <div><img src={item.img} alt={item.title} /></div>
                </div>
                <div className="blog-post-content">
                  <h4 className='text-center' >{item.title}</h4>
                  <p className='text-center' >{item.description}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
        <Slider
          className="released-game-active hidden md-show"
          arrows={false}
          autoplay={true}
          slidesToShow={1}
          autoplaySpeed={3000}
        >
          {gameContents.map((item, i) => (
            <div key={i} className="col-lg-3 col-md-6 col-sm-9 flex">
              <div className="blog-post home-four-blog-post mb-50">
                <div className="blog-thumb mb-30 flex">
                  <a href="/#"><img src={item.img} alt={item.title} /></a>
                </div>
                <div className="blog-post-content">
                  <h4 className='text-center' >{item.title}</h4>
                  <p className='text-center' >{item.description}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
        {/* </div> */}
      </div>
    </section>
  )
}

export default BlogArea
